
export const closeAddJobDialogReducer = (state) => {
    state.addJobDialog.isOpen = false;
}
